import React from "react";
import { withRouter } from 'react-router-dom';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { Badge, LinkList, Typography } from "../ecosystem";
import ErrorLoadingTileMessage from "../common/ErrorLoadingTileMessage";

/**
 * Container component for the PharmacyTile page.
 * 
 */
export class PharmacyTile extends React.Component {

    constructor(props, params) {
        super(props, params);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.PharmacyTile.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        if (typeof window === 'undefined') {
            return null;
        }

        const { defaultPharmacy, error, pharmacyDetails, rxHome } = this.props;
        const pharmacyName = (defaultPharmacy && defaultPharmacy?.Name) ? defaultPharmacy?.Name : '';
        const address = (defaultPharmacy && defaultPharmacy?.Address) ? defaultPharmacy?.Address : '';
        const phone = (defaultPharmacy && defaultPharmacy?.PhoneNumber) ? defaultPharmacy?.PhoneNumber : '';

        const pharmacyCount = parseInt(pharmacyDetails?.ReadyForPickUpCount + pharmacyDetails?.RxRefillCount + pharmacyDetails?.TransferInProgressCount);

        return (
            <React.Fragment>
                {!error
                    ? <div className="pharmacy-tile__active">
                        <LinkList
                            list={[
                                {
                                    ...rxHome,
                                    text: <><span className="pharmacy-tile__link-label">Prescriptions Ready for Pickup</span><Badge count={pharmacyDetails?.ReadyForPickUpCount} show={pharmacyDetails?.ReadyForPickUpCount && pharmacyDetails?.ReadyForPickUpCount > 0} colorStyle="subtle" /></>,
                                    onClick: (e) => { logUI(`MBHWeb.UI.PharmacyTile.Pickup.Clicked`, new Date(), Tools.getURLPath()); },
                                },
                                {
                                    ...rxHome,
                                    text: <><span className="pharmacy-tile__link-label">Prescriptions to Refill</span><Badge count={pharmacyDetails?.RxRefillCount} show={pharmacyDetails?.RxRefillCount && pharmacyDetails?.RxRefillCount > 0} colorStyle="subtle" /></>,
                                    onClick: (e) => { logUI(`MBHWeb.UI.PharmacyTile.Refill.Clicked`, new Date(), Tools.getURLPath()); },
                                },
                                {
                                    ...rxHome,
                                    text: <><span className="pharmacy-tile__link-label">Transfer In Progress</span><Badge count={pharmacyDetails?.TransferInProgressCount} show={pharmacyDetails?.TransferInProgressCount && pharmacyDetails?.TransferInProgressCount > 0} colorStyle="subtle" /></>,
                                    onClick: (e) => { logUI(`MBHWeb.UI.PharmacyTile.Transfer.Clicked`, new Date(), Tools.getURLPath()); },
                                },
                            ]}
                        />
                    </div>
                    : <ErrorLoadingTileMessage />
                }
            </React.Fragment>
        );
    }
}

export default withRouter(PharmacyTile);